import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddBatchComponent } from '../add-batch/add-batch.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'mega-store-factory-add-rack',
  templateUrl: './add-rack.component.html',
  styleUrls: ['./add-rack.component.scss']
})
export class AddRackComponent {
  form: FormGroup = new FormGroup({});
  formType: string = '';
  title: string = '';

  constructor(
    public dialogRef: MatDialogRef<AddBatchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formType = data.type || 'zone';
    this.title = data.title || 'Add';
    this.initializeForm();
  }

  initializeForm() {
    switch (this.formType) {
      case 'zone':
        this.form = new FormGroup({
          name: new FormControl(this.data.element?.name || '', [Validators.required]),
          abbreviation: new FormControl(this.data.element?.abbreviation || '', [Validators.required])
        });
        break;

      case 'level':
        this.form = new FormGroup({
          level: new FormControl(this.data.element?.level || '', [Validators.required])
        });
        break;

      case 'shelve':
        // For shelves, strip the "S" prefix when editing
        const shelveValue = this.data.element?.shelve || '';
        const numberValue = shelveValue.startsWith('S') ? shelveValue.substring(1) : shelveValue;
        
        this.form = new FormGroup({
          shelve: new FormControl(numberValue, [
            Validators.required,
            Validators.pattern(/^\d+$/) // Only allow numbers
          ])
        });
        break;

      default:
        this.form = new FormGroup({
          name: new FormControl('', [Validators.required])
        });
    }
    console.log('Form:', this.form);
  }

  onSubmit() {
    console.log('Form submitted:', this.form);
    if (this.form.valid) {
      // Send form value as is - backend will handle "S" prefix for shelves
      this.dialogRef.close(this.form.value);
    } else {
      this.markFormGroupTouched();
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  private markFormGroupTouched() {
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
  }

  getFieldError(fieldName: string): string {
    const control = this.form.get(fieldName);
    if (control && control.errors && control.touched) {
      if (control.errors['required']) {
        return `${fieldName} is required`;
      }
      if (control.errors['pattern'] && fieldName === 'shelve') {
        return 'Only numbers are allowed';
      }
    }
    return '';
  }
}
